"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _classnames = require("classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchInput = (_temp = _class = function (_Component) {
  _inherits(SearchInput, _Component);

  function SearchInput(props) {
    _classCallCheck(this, SearchInput);

    var _this = _possibleConstructorReturn(this, (SearchInput.__proto__ || Object.getPrototypeOf(SearchInput)).call(this, props));

    _this.handleClearSearch = function () {
      var onSearch = _this.props.onSearch;

      _this.setState({
        value: ""
      }, function () {
        return onSearch("");
      });
      _this.searchInput.focus();
    };

    _this.handleSearch = function (evt) {
      var onSearch = _this.props.onSearch;
      var value = evt.target.value;

      _this.setState({ value: value }, function () {
        return onSearch(value);
      });
    };

    _this.state = {
      value: props.value || ""
    };
    return _this;
  }

  _createClass(SearchInput, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value !== undefined) {
        this.setState({
          value: nextProps.value
        });
      }
    }
  }, {
    key: "renderClearBtn",
    value: function renderClearBtn() {
      var clearBtnClassName = this.props.clearBtnClassName;
      var value = this.state.value;

      if (!value) {
        return null;
      }
      return _react2.default.createElement("button", {
        className: (0, _classnames2.default)("fa fa-times-circle form-control-feedback erg-input-clear", clearBtnClassName),
        onClick: this.handleClearSearch });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          inputClassName = _props.inputClassName,
          placeholder = _props.placeholder;
      var value = this.state.value;

      var rootClass = (0, _classnames2.default)("erg-components-SearchInput", "erg-navbar-search-container", "form-group", "has-feedback", className);
      return _react2.default.createElement(
        "div",
        { className: rootClass },
        _react2.default.createElement("input", {
          className: (0, _classnames2.default)("erg-components-SearchInput erg-navbar-search form-control", inputClassName),
          onChange: this.handleSearch,
          placeholder: placeholder,
          ref: function ref(el) {
            return _this2.searchInput = el;
          },
          type: "text",
          value: value }),
        this.renderClearBtn()
      );
    }
  }]);

  return SearchInput;
}(_react.Component), _class.displayName = "SearchInput", _class.propTypes = {
  className: _propTypes2.default.string,
  clearBtnClassName: _propTypes2.default.string,
  inputClassName: _propTypes2.default.string,
  onSearch: _propTypes2.default.func.isRequired,
  placeholder: _propTypes2.default.string,
  value: _propTypes2.default.string
}, _class.defaultProps = {
  placeholder: "Search for..."
}, _temp);
exports.default = SearchInput;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-components-react/lib/SearchInput.js
 ** module id = 790
 ** module chunks = 0
 **/